import {
  NoItemsAvailableSecondary,
  NoResultsSecondary,
} from "@/assets/illustrations";
import {
  NO_RESULTS_TITLE,
  NO_RESULTS_SUBTITLE,
  NO_SEARCH_RESULTS_TITLE,
  NO_SEARCH_RESULTS_SUBTITLE,
  NO_SEARCH_RESULTS_WITH_FILTERS_TITLE,
  NO_SEARCH_RESULTS_WITH_FILTERS_SUBTITLE,
  NO_RESULTS_FOR_FILTERS_TITLE,
} from "./constants";
import { EmptyDataScreenTypes } from "./types";

export const EMPTY_DATA_STATES = {
  [EmptyDataScreenTypes.NoResults]: {
    ICON: <NoItemsAvailableSecondary />,
    TITLE: NO_RESULTS_TITLE,
    SUBTITLE: NO_RESULTS_SUBTITLE,
  },
  [EmptyDataScreenTypes.NoSearchResults]: {
    ICON: <NoResultsSecondary />,
    TITLE: NO_SEARCH_RESULTS_TITLE,
    SUBTITLE: NO_SEARCH_RESULTS_SUBTITLE,
  },
  [EmptyDataScreenTypes.NoSearchResultsWithFilters]: {
    ICON: <NoResultsSecondary />,
    TITLE: NO_SEARCH_RESULTS_WITH_FILTERS_TITLE,
    SUBTITLE: NO_SEARCH_RESULTS_WITH_FILTERS_SUBTITLE,
  },
  [EmptyDataScreenTypes.NoResultsForFilters]: {
    ICON: <NoResultsSecondary />,
    TITLE: NO_RESULTS_FOR_FILTERS_TITLE,
    SUBTITLE: "",
  },
};
